import { useLoggedInUser } from '@tcc/shared-data-lib';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useUserLoggedInConfigs } from '../utils/sharedData';
import {
  getIsGlanceFeatureFlagEnable,
  initializeGlance,
} from '../utils/glance';

// Cobrowsing is a feature that allows user to share their browser screen with the
// support teams, so they can triage problems. It is turn it on on-demand via feature flag.
export const useCobrowsingSupport = () => {
  const { user } = useLoggedInUser(useUserLoggedInConfigs);
  const [ isLoading, setIsLoading] = useState(false);
  const hasBoot = useRef(false);

  const boot = useCallback(async () => {
    if (!user || hasBoot.current) return;
    hasBoot.current = true;
    
    const isGlanceEnable = await getIsGlanceFeatureFlagEnable(user.id);
    if (isGlanceEnable) initializeGlance(user.id);
    setIsLoading(true);
  }, [user]);

  useEffect(() => {
    boot();
  }, [boot]);

  return { isLoading };
};
